/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable react/no-unstable-nested-components */
import { zodResolver } from "@hookform/resolvers/zod";
import SelectIndicators from "components/financials/modern/indicators/SelectIndicators";
import type { TemplateFormData } from "components/financials/modern/templates/form";
import { TemplateFormSchema } from "components/financials/modern/templates/form";
import { Button } from "components/ui/Button";
import { Checkbox } from "components/ui/Checkbox";
import { Form, FormField, FormMessage } from "components/ui/Form";
import { Input, TextArea } from "components/ui/Input";
import classNames from "components/ui/classNames";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import type { IIndicatorsFilters } from "types/graphqlTypes";

interface DefineTemplateFormProps {
  filters?: IIndicatorsFilters;
  defaultValues: TemplateFormData;
  onCancel: () => void;
  onSubmit: (data: TemplateFormData) => void;
}
export default function DefineTemplateForm({ filters, defaultValues, onCancel, onSubmit }: DefineTemplateFormProps) {
  const intl = useIntl();
  const form = useForm<TemplateFormData>({
    mode: "onSubmit",
    resolver: zodResolver(TemplateFormSchema),
    defaultValues,
  });

  // eslint-disable-next-line no-underscore-dangle
  const _onSubmitProxy = async (values: TemplateFormData) => {
    onSubmit(values);
  };

  return (
    <Form {...form}>
      <div className="space-y-6">
        <form autoComplete="off" className="space-y-4" onSubmit={form.handleSubmit(_onSubmitProxy)} noValidate={true}>
          <div className="flex flex-1 items-center space-x-2">
            <Button
              size="full"
              variant="ghost"
              type="button"
              className={classNames(
                "bg-rose-50/50 text-rose-600",
                "hover:bg-rose-50",
                "dark:bg-rose-900/40 dark:text-rose-300",
                "dark:hover:bg-rose-600 dark:hover:text-white",
              )}
              onClick={onCancel}
            >
              <FormattedMessage defaultMessage="Cancelar" id="nZLeaQ" />
            </Button>
            <Button
              size="full"
              variant="ghost"
              type="submit"
              className={classNames(
                "bg-indigo-50/50 text-indigo-600",
                "hover:bg-indigo-50",
                "dark:bg-indigo-900/40 dark:text-indigo-300",
                "dark:hover:bg-indigo-600/60 dark:hover:text-white",
              )}
            >
              <FormattedMessage defaultMessage="Salvar" id="DFil5M" />
            </Button>
          </div>

          <div
            className={classNames(
              "flex-col items-center justify-center space-y-4 rounded-xl border border-slate-200 bg-slate-50 p-4 dark:bg-slate-900",
              "dark:border-slate-950",
            )}
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => {
                return (
                  <div className="space-y-2">
                    <Input
                      {...field}
                      autoComplete="off"
                      placeholder={intl.formatMessage({ defaultMessage: "Nome", id: "CH/6DN" })}
                    />
                    <FormMessage />
                  </div>
                );
              }}
            />

            <FormField
              control={form.control}
              name="description"
              render={({ field }) => {
                return (
                  <div className="space-y-2">
                    <TextArea
                      {...field}
                      placeholder={intl.formatMessage({ defaultMessage: "Escreva uma descrição...", id: "RHt4YU" })}
                      rows={2}
                    />

                    <FormMessage />
                  </div>
                );
              }}
            />

            <label
              htmlFor="isGlobalForVerticals"
              className="flex items-center gap-x-2 text-xs font-semibold uppercase text-gray-600 dark:text-slate-400"
            >
              <FormField
                control={form.control}
                name="isGlobalForVerticals"
                render={({ field }) => {
                  return <Checkbox id="isGlobalForVerticals" checked={field.value} onCheckedChange={field.onChange} />;
                }}
              />

              <FormattedMessage defaultMessage="Habilitar para todas as empresas" id="Tofy82" />
            </label>
          </div>
        </form>

        <div className="flex-col items-center justify-center space-y-4 rounded-xl">
          <FormField
            control={form.control}
            name="indicators"
            render={({ field }) => {
              return (
                <SelectIndicators
                  filters={filters}
                  selectedIndicators={field.value}
                  onSelectIndicators={field.onChange}
                />
              );
            }}
          />
        </div>
      </div>
    </Form>
  );
}
